exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scan-item[data-v-98d816c2]{\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  padding: 15px;\n  border: 0.4px solid #8e898990;\n  margin: 10px 0;\n  min-width: 100px;\n}\n", ""]);

// exports
